import React, { memo, useCallback, useEffect, useState } from 'react';
import Popover, { PopoverProps } from 'antd/lib/popover';
import c from 'classnames';
import { ModalsZIndex } from 'src/components/constants';
import { useOverlayStackDepth } from 'src/components/providers/overlay-stack-depth-provider';

export type LggPopoverProps = Omit<PopoverProps, 'zIndex'> & {
  hideArrow?: boolean;
};

export const LggPopover = memo<LggPopoverProps>(
  ({
    children,
    hideArrow = false,
    overlayClassName = '',
    visible,
    onVisibleChange,
    ...rest
  }) => {
    const [internalVisible, setInternalVisible] = useState(visible ?? false);
    const stackDepth = useOverlayStackDepth(internalVisible);

    useEffect(() => {
      if (visible !== undefined) setInternalVisible(visible);
    }, [visible]);

    const handleVisibleChange = useCallback(
      (nextVisible: boolean) => {
        if (visible === undefined) setInternalVisible(nextVisible);
        onVisibleChange?.(nextVisible);
      },
      [visible, onVisibleChange],
    );

    return (
      <Popover
        overlayClassName={`${c({
          'lgg-popover': true,
          'arrow-hidden': hideArrow,
        })} ${overlayClassName}`}
        {...rest}
        visible={visible}
        onVisibleChange={handleVisibleChange}
        zIndex={ModalsZIndex + (stackDepth ?? 0)}
      >
        {children}
      </Popover>
    );
  },
);
